export default "__VITE_ASSET__aB9L0I1w__"